module.exports = __webpack_public_path__ + "static/media/OFL.7f788d6c.7f788d6c.txt";